import { FormlyFieldConfig } from '@ngx-formly/core';
import { formatNumber } from '@portal/util';

export function maxValidatorMessage(error: unknown, field: FormlyFieldConfig): string {
  return `This value must be less than ${formatNumber(field.props?.max)}`;
}
